// extracted by mini-css-extract-plugin
export var root = "_45m7";
export var rootBadge = "SDSv";
export var rootHiddenDesktop = "XiCx";
export var rootHiddenMobile = "xkhq";
export var rootIcon = "bHLT";
export var rootIconWrapper = "FeEI";
export var rootLabel = "pRzD";
export var rootcalculator = "Dppj";
export var rootreferral = "mMl0";